import React from 'react'
import { css } from '@emotion/core'
import { DiscussionLink, PersonLink, RelationshipLink, UserLink } from '../../app/Links'
import LabelAndData from '../../common/LabelAndData'

const wrapText = css`
  word-break: break-word;
  overflow-wrap: break-word;
`

export default function PersonChangesLabelAndData({ label, data, idsMetadata, changeType }) {
  if (!data) {
    return null
  }
  let displayData = null

  if (idsMetadata[data]) {
    if (idsMetadata[data].type === 'PERSON') {
      displayData = <PersonLink personId={data} personName={idsMetadata[data].friendlyName} showId />
    } else if (
      idsMetadata[data].type === 'CONTRIBUTOR' ||
      idsMetadata[data].type === 'SUBMITTER' ||
      idsMetadata[data].type === 'CONTRIBUTOR_AND_SUBMITTER'
    ) {
      displayData = <UserLink userId={data} userName={idsMetadata[data].friendlyName} showId />
    } else if (idsMetadata[data].type === 'AGENT_APP') {
      displayData = <span>{idsMetadata[data].friendlyName}</span>
    } else if (idsMetadata[data].type === 'ASSOCIATION') {
      displayData = <RelationshipLink relationshipType="association" relationshipId={idsMetadata[data].id} />
    }
  } else if (label === 'URI') {
    switch (changeType) {
      case 'DISCUSSION':
      case 'SOURCE':
        displayData = <DiscussionLink uri={data} />
        break
      default:
        displayData = <span css={wrapText}>{data}</span>
        break
    }
  } else {
    displayData = <span css={wrapText}>{data}</span>
  }

  return <LabelAndData label={label} displayData={displayData} />
}
